import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/heart.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/heart-full.svg';
import showNotification from '~/helpers/notification-helper';
export default {
  name: 'Heart',
  props: {
    reference: {
      type: String,
      required: true
    },
    withText: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      mdmUrls: {
        moodboard: '/user/wishlist'
      }
    };
  },
  computed: _objectSpread({}, mapGetters({
    user: 'user/me',
    items: 'wishlist/items'
  }), {
    isInWishlist: function isInWishlist() {
      return this.includesRef(this.reference);
    },
    btnText: function btnText() {
      return this.isInWishlist ? this.$t('delete.btn_label') : this.$t('add.btn_label');
    }
  }),
  methods: _objectSpread({}, mapActions({
    fetchWishlist: 'wishlist/fetchWishlistItems',
    addWishlistItem: 'wishlist/addWishlistItem',
    deleteWishlistItem: 'wishlist/deleteWishlistItem'
  }), {
    toggleWishlist: function toggleWishlist(ref, $event) {
      if (this.includesRef(ref)) {
        this.removeFromWishlist(ref, $event);
      } else {
        this.addToWishlist(ref, $event);
      }
    },
    includesRef: function includesRef(ref) {
      return Boolean(this.getWishlistItem(ref));
    },
    addToWishlist: function () {
      var _addToWishlist = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(ref, $event) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.user) {
                  _context.next = 4;
                  break;
                }

                this.$root.$emit('open-layer', {
                  state: true,
                  name: 'LoginRegister'
                });
                this.tracking({
                  ref: ref,
                  action: 'Add-to-wishlist',
                  label: 'not_connected',
                  el: $event
                });
                return _context.abrupt("return");

              case 4:
                this.tracking({
                  ref: ref,
                  action: 'Add-to-wishlist',
                  el: $event
                });
                _context.next = 7;
                return this.addWishlistItem(ref);

              case 7:
                this.fetchWishlist();
                showNotification({
                  text: this.$i18n.messages[this.$store.state.i18n.currentLocale.language].add.subtitle,
                  destination: "/".concat(this.$store.state.i18n.currentLocale.market, "/").concat(this.$store.state.i18n.currentLocale.language).concat(this.mdmUrls.moodboard),
                  backgroundColor: 'green'
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addToWishlist(_x, _x2) {
        return _addToWishlist.apply(this, arguments);
      }

      return addToWishlist;
    }(),
    removeFromWishlist: function () {
      var _removeFromWishlist = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(ref, $event) {
        var wishlistItem;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.user) {
                  _context2.next = 4;
                  break;
                }

                this.$root.$emit('open-layer', {
                  state: true,
                  name: 'LoginRegister'
                });
                this.tracking({
                  ref: ref,
                  action: 'Remove-from-wishlist',
                  label: 'not_connected',
                  el: $event
                });
                return _context2.abrupt("return");

              case 4:
                this.tracking({
                  ref: ref,
                  action: 'Remove-from-wishlist',
                  el: $event
                });
                wishlistItem = this.getWishlistItem(ref);
                this.deleteWishlistItem(wishlistItem.reference);
                showNotification({
                  text: this.$i18n.messages[this.$store.state.i18n.currentLocale.language].delete.subtitle,
                  destination: "/".concat(this.$store.state.i18n.currentLocale.market, "/").concat(this.$store.state.i18n.currentLocale.language).concat(this.mdmUrls.moodboard),
                  backgroundColor: 'green'
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function removeFromWishlist(_x3, _x4) {
        return _removeFromWishlist.apply(this, arguments);
      }

      return removeFromWishlist;
    }(),
    tracking: function () {
      var _tracking = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(_ref) {
        var ref, action, label, el, category, defaultLabel;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                ref = _ref.ref, action = _ref.action, label = _ref.label, el = _ref.el;
                category = '';

                if (window.tc_vars.env_template === 'listproduct_keyword') {
                  category = 'Search Page';
                }

                if (window.tc_vars.env_template === 'liste produits') {
                  category = 'Categorie';
                }

                if (window.tc_vars.env_template === 'page produit') {
                  category = 'FicheProduit';
                }

                defaultLabel = "".concat(window.tc_vars.page_cat1 || '', "_").concat(window.tc_vars.page_cat3 || '', "_").concat(ref);
                this.$root.$emit('generic-tracking', el, {
                  data: {
                    event_category: category,
                    event_action: action,
                    event_label: label || defaultLabel
                  }
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function tracking(_x5) {
        return _tracking.apply(this, arguments);
      }

      return tracking;
    }(),
    getWishlistItem: function getWishlistItem(ref) {
      return this.items.find(function (e) {
        return e.product && e.product.reference === ref;
      });
    }
  })
};